// Libraries
var React = require('react');

// Styles
require('./FixturePromotion.scss');

const PromoContent = props => props.link ? (
	<a href={props.link.url} target={props.newWindow ? "_blank" : "_self"} rel={props.newWindow ? "noopener noreferrer" : undefined}>
		{props.children}
	</a>
) : (
	<div>
		{props.children}
	</div>
);


const FixturePromotion = props => {
	const desktopImg = props.promotion.desktopImage;
	const mobileImg = props.promotion.mobileImage;

	const promoImg = (cls, imgUrl) => (
		<span style={{backgroundImage: `url(${imgUrl})`}} className={cls} />
	);

	return (
		<div className="FixturePromotion">
			<PromoContent link={props.promotion.link} newWindow={props.newWindow}>
				{mobileImg &&
					promoImg('banner-image', mobileImg.url)
				}
				{desktopImg &&
					promoImg('portrait-image', desktopImg.url)
				}
			</PromoContent>
		</div>
	);
};

module.exports = FixturePromotion;



// WEBPACK FOOTER //
// ./src/components/Fixtures/FixturePromotion.js